module.exports = __webpack_public_path__ + "img/undraw_fitness_stats_sht6.fed2069b.svg";